import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useJitsu } from "@jitsu/jitsu-react";

import Home from "./pages/Home";
import Blogs from "./pages/Blogs";
import BlogPost from "./pages/BlogPost";
import NotFound from "./pages/NotFound";
import { getOrCreateSessionId } from "./lib/session";

type Attribution = {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string | null;
  ref_code: string | null;
};

function getAttribution(): Attribution {
  const params = new URLSearchParams(window.location.search);
  const hasAttribution =
    params.has("utm_source") ||
    params.has("utm_medium") ||
    params.has("utm_campaign") ||
    params.has("ref");

  if (hasAttribution) {
    const attribution: Attribution = {
      utm_source:   params.get("utm_source")   ?? "direct",
      utm_medium:   params.get("utm_medium")   ?? "none",
      utm_campaign: params.get("utm_campaign"),
      ref_code:     params.get("ref"),
    };
    // Persiste para as próximas navegações da mesma sessão
    sessionStorage.setItem("attribution", JSON.stringify(attribution));
    return attribution;
  }

  const stored = sessionStorage.getItem("attribution");
  if (stored) return JSON.parse(stored) as Attribution;

  return { utm_source: "direct", utm_medium: "none", utm_campaign: null, ref_code: null };
}

function RouteTracker() {
  const location = useLocation();
  const { analytics } = useJitsu();

  useEffect(() => {
    const session_id = getOrCreateSessionId();
    const attribution = getAttribution();

    analytics.track("page_view", {
      session_id,
      path: location.pathname,
      search: location.search,
      full_path: location.pathname + location.search,
      ...attribution,
    });
  }, [location, analytics]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <RouteTracker />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:slug" element={<BlogPost />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}